import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { MaintenanceRequestRunBookSettings } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const RUN_BOOKS_SETTINGS_URL = `${SETTINGS_BASE_URL}/maintenancerequestrunbook`;

export class runBooksSettingsRepository extends BaseRestRepository {
  public async changeRunBooksSettings(payload: MaintenanceRequestRunBookSettings) {
    const url = `${RUN_BOOKS_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getAllRunBooksSettings() {
    const url = `${RUN_BOOKS_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateRunBooksSettingsByLevel(level: string, levelId: string, payload: MaintenanceRequestRunBookSettings) {
    const url = RUN_BOOKS_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteRunBooksSettingsByLevel(level: string, levelId: string) {
    const url = `${RUN_BOOKS_SETTINGS_URL}/${level}/${levelId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
